import { render, staticRenderFns } from "./ChatNavigationIcon.vue?vue&type=template&id=a0613238&scoped=true"
import script from "./ChatNavigationIcon.vue?vue&type=script&lang=js"
export * from "./ChatNavigationIcon.vue?vue&type=script&lang=js"
import style0 from "./ChatNavigationIcon.vue?vue&type=style&index=0&id=a0613238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0613238",
  null
  
)

export default component.exports